import * as ActionTypes from '../ActionTypes';

export const GetWeekDaysAction = () => {
    return {
        type: ActionTypes.WEEK_DAYS_GET_REQUEST,
    }
}
